import { mediaGQLFields } from '../media/index.js';
import { memberAuthMemberPropsGQLFields, } from '../permission/index.js';
import { memberBadgeGQLFields } from './badge.fields.js';
import { roleGQLFields } from './role.fields.js';
const BASIC_MEMBER_FIELDS = {};
const ALL_MEMBER_FIELDS = {
    profilePicture: 'basic',
    badges: 'basic',
    banner: 'basic',
    authMemberProps: 'basic',
    fields: 'basic',
    sessions: 'basic',
    activeSession: 'basic',
    score: 'basic',
    settings: 'basic',
    blockedMembers: 'basic',
};
const DEFAULT_MEMBER_FIELDS = {
    authMemberProps: 'all',
    badges: 'default',
    banner: 'all',
    profilePicture: 'all',
    role: 'basic',
    fields: 'all',
    settings: 'basic',
    extraProperties: {
        variables: {},
    },
};
export function memberGQLFields(fields) {
    var _a, _b;
    if (fields === 'basic') {
        fields = BASIC_MEMBER_FIELDS;
    }
    if (fields === 'all') {
        fields = ALL_MEMBER_FIELDS;
    }
    if (fields === 'default') {
        fields = DEFAULT_MEMBER_FIELDS;
    }
    return `
    displayName
    name
    id
    locale
    profilePictureId
    bannerId
    status
    username
    email
    emailStatus
    newEmail
    tagline
    lastSeenAt
    createdAt
    updatedAt
    relativeUrl
    url
    externalId
    roleId
    flagged
    teammate
    ${fields.role
        ? `
        role {
          ${roleGQLFields(fields.role)}
        }
      `
        : ''}
    ${fields.banner
        ? `
      banner {
        ${mediaGQLFields(fields.banner)}
      }
    `
        : ``}
    ${fields.profilePicture
        ? `
      profilePicture {
        ${mediaGQLFields(fields.profilePicture)}
      }
    `
        : ``}
    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${memberAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
    ${fields.badges
        ? `
      badges {
        ${memberBadgeGQLFields(fields.badges)}
      }
    `
        : ``}    
    ${fields.fields
        ? `
      fields {
        key
        value
      }
    `
        : ``}
    ${fields.sessions
        ? `
      sessions {
        active
        country
        createdAt
        deviceBrand
        id
        ip
        lastActivityAt
        os
        osVersion
      }
    `
        : ``}
    ${fields.activeSession
        ? `
      activeSession {
        active
        country
        createdAt
        deviceBrand
        id
        ip
        lastActivityAt
        os
        osVersion
      }
    `
        : ``}
    ${fields.score ? 'score' : ''}
    ${(fields === null || fields === void 0 ? void 0 : fields.extraProperties)
        ? `
      extraProperties ${((_b = (_a = fields === null || fields === void 0 ? void 0 : fields.extraProperties) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b.keys)
            ? `(keys: ["${fields.extraProperties.variables.keys.join('","')}"])`
            : ``} {
        key
        value
      }
    `
        : ``}
    ${fields.settings
        ? `
    settings {
      privateMessaging {
        privateMessagingEnabled
      }
    }
    `
        : ``}
    ${fields.blockedMembers
        ? `
       blockedMemberIds
       blockedMembers {
        ${memberGQLFields(fields.blockedMembers)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=member.fields.js.map